import { render, staticRenderFns } from "./External-Description.vue?vue&type=template&id=3e1f2c77&lang=pug"
import script from "./External-Description.vue?vue&type=script&setup=true&lang=ts"
export * from "./External-Description.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports